import { classnames } from 'tailwindcss-classnames';
import PlaceholderWrapper from 'components/helpers/PlaceholderWrapper/PlaceholderWrapper';
import { DesktopTabsProps, TabProps } from './_types';

export const DesktopHorizontalTabsLayout = ({
  fields,
  rendering,
  visibleItem,
  toggleItemVisibility,
}: DesktopTabsProps) => {
  const categories = fields?.tabsItems as TabProps[];
  const noCategories = !categories || categories.length === 0;

  return (
    <>
      {noCategories && <span>Add a tab to get started.</span>}
      <div className={classnames({ hidden: noCategories })}>
        <ul
          className={classnames(`flex`, `border-solid`, `border-gray-midGray`, `border-b`)}
          data-nmdp-tabstrip="tabstrip"
        >
          {categories.map((item) => (
            <li
              className={classnames({
                ['border-blue-navy']: item.id === visibleItem,
                'border-b-4': item.id === visibleItem,
              })}
              key={item.id}
            >
              <button
                type="button"
                className={classnames(`pt-5`, `px-[16px]`, `text-gray-darkGray`, `cursor-pointer`, {
                  ['font-semibold']: item.id === visibleItem,
                })}
                data-nmdp-tab={item?.id}
                onClick={() => toggleItemVisibility(item?.id)}
              >
                <div
                  className={classnames({
                    ['text-blue-navy']: item.id === visibleItem,
                  })}
                  key={item.id}
                >
                  {item?.displayName}
                </div>
              </button>
            </li>
          ))}
        </ul>
        {categories.map((item, index) => (
          <div
            className={classnames(`p-5`, `mt-2`, `w-full`, `h-full`, {
              hidden: visibleItem !== item.id,
            })}
            key={item.id}
            data-nmdp-tab={index}
          >
            <PlaceholderWrapper
              name={`nmdp-tabs-content-${String.fromCharCode(index + 97)}`}
              rendering={rendering}
            />
          </div>
        ))}
      </div>
    </>
  );
};
